import HttpError from '../errors/http_error';

class Api {
  token: string;
  baseUrl: string;

  constructor(token: string) {
    this.token = token;
    this.baseUrl = "";
  }

  async uploadFile(url: string, formData: FormData): Promise<any> {
    const baseRequest = this.createBaseRequest('POST');
    delete (baseRequest.headers as Record<string, string>)['Content-Type'];
    (baseRequest as any).body = formData;

    const result = await this.fetchWithErrors(`${this.baseUrl}${url}`, baseRequest as RequestInit);
    const json = await result.json();
    return json;
  }

  createBaseRequest(method: string): { method: string; headers: Record<string, string> } {
    return {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`
      }
    };
  }

  request(method = 'GET', headers: Record<string, string> = {}, body: Record<string, any> = {}): RequestInit {
    const baseRequest = this.createBaseRequest(method);
    baseRequest.headers = { ...baseRequest.headers, ...headers };

    const init: RequestInit = {
      method: baseRequest.method,
      headers: baseRequest.headers,
    };

    if (method !== 'GET' && method !== 'HEAD') {
      init.body = JSON.stringify(body);
    }

    return init;
  }

  async fetchWithErrors(url: string, request: RequestInit): Promise<Response> {
    const data = await fetch(url, request);
    if (!data.ok) {
      throw new HttpError(data);
    }
    return data;
  }

  async actionWithoutBody(url: string, method = 'GET'): Promise<any> {
    const data = await this.fetchWithErrors(`${this.baseUrl}${url}`, this.request(method));
    const respBody = await data.text();
    if (respBody.length > 0) {
      return JSON.parse(respBody);
    }
    return data;
  }

  async actionWithBody(url: string, body: Record<string, any>, method = 'POST'): Promise<any> {
    const data = await this.fetchWithErrors(`${this.baseUrl}${url}`, this.request(method, {}, body));
    const respBody = await data.text();
    if (respBody.length > 0) {
      return JSON.parse(respBody);
    }
    return data;
  }

  async get(url: string): Promise<any> {
    return await this.actionWithoutBody(url);
  }

  async delete(url: string): Promise<any> {
    return await this.actionWithoutBody(url, 'DELETE');
  }

  async post(url: string, body: Record<string, any>): Promise<any> {
    return await this.actionWithBody(url, body);
  }

  async put(url: string, body: Record<string, any>): Promise<any> {
    return await this.actionWithBody(url, body, 'PUT');
  }

  async patch(url: string, body: Record<string, any>): Promise<any> {
    return await this.actionWithBody(url, body, 'PATCH');
  }
}

const useApi = (apiToken?: string): Api => {
  return new Api(apiToken || '');
};

export default useApi;
export { Api };
